import { useQsFilters } from "@dash/filters";

import {
  SupportTicketFilters,
  supportTicketFiltersSerializer,
  SupportTicketSortField,
  SupportTicketSortOrder,
} from "@megaron/megarax-uri";
import { ticketStatuses } from "@megaron/support-contracts";
import type { TicketStatus } from "@megaron/support-contracts";

export type SupportTicketsSortValue = {
  field: SupportTicketSortField;
  order: SupportTicketSortOrder;
};

const defaultActiveStatuses: TicketStatus[] = ticketStatuses.filter(
  (s): s is TicketStatus => s !== "resolved" && s !== "closed",
);

const defaultFilters: SupportTicketFilters = {
  page: 0,
  searchText: "",
  status: defaultActiveStatuses,
  priority: [],
  category: [],
  tags: [],
  sort: "updatedAt",
  sortOrder: "DESC",
  myTickets: undefined,
  isRead: undefined,
};

export const useSupportTicketsFilters = () => {
  const { filters, setFilters, setFilter } = useQsFilters<SupportTicketFilters>(
    supportTicketFiltersSerializer,
    defaultFilters,
    "filters",
  );

  return { filters, setFilter, setFilters, defaultFilters };
};
